import { render, staticRenderFns } from "./FancyTextareaBox.vue?vue&type=template&id=e648837e&"
import script from "./FancyTextareaBox.vue?vue&type=script&lang=js&"
export * from "./FancyTextareaBox.vue?vue&type=script&lang=js&"
import style0 from "./FancyTextareaBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Ampps\\www\\strana\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e648837e')) {
      api.createRecord('e648837e', component.options)
    } else {
      api.reload('e648837e', component.options)
    }
    module.hot.accept("./FancyTextareaBox.vue?vue&type=template&id=e648837e&", function () {
      api.rerender('e648837e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/resources/js/components/FancyTextareaBox.vue"
export default component.exports